import React, { useState } from 'react';
import './Login.css';
import { login } from "./features/userSlice";
import { auth } from "./firebase";
import { useDispatch } from 'react-redux';
import { 
  createUserWithEmailAndPassword, 
  updateProfile, 
  signInWithEmailAndPassword 
} from 'firebase/auth';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [profilePic, setProfilePic] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const loginToApp = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("Please enter both email and password!");
      return;
    }

    setLoading(true);

    try {
      const userAuth = await signInWithEmailAndPassword(auth, email, password);

      dispatch(
        login({
          email: userAuth.user.email,
          uid: userAuth.user.uid,
          displayName: userAuth.user.displayName,
          profileUrl: userAuth.user.photoURL,
        })
      );
    } catch (error) {
      console.error("Login error:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const register = async () => {
    if (!name) {
      alert("Please enter a full name!");
      return;
    }
    if (!email || !password) {
      alert("Please enter email and password to register!");
      return;
    }

    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

      await updateProfile(userCredential.user, {
        displayName: name,
        photoURL: profilePic || '',
      });

      dispatch(
        login({
          email: userCredential.user.email,
          uid: userCredential.user.uid,
          displayName: name,
          profileUrl: profilePic || '',
        })
      );
    } catch (error) {
      console.error("Registration error:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login'>
      <img
        src="https://news.hitb.org/sites/default/files/styles/large/public/field/image/500px-LinkedIn_Logo.svg__1.png"
        alt="LinkedIn Logo"
      />

      <form onSubmit={loginToApp}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='Full name (required if registering)'
          type='text'
          name="name"
          id="name"
        />

        <input
          value={profilePic}
          onChange={(e) => setProfilePic(e.target.value)}
          placeholder='Profile pic URL (optional)'
          type='text'
          name="profilePic"
          id="profilePic"
        />

        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='Email'
          type='email'
          name="email"
          id="email"
          autoComplete="email"
          required
        />

        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder='Password'
          type='password'
          name="password"
          id="password"
          autoComplete="current-password"
          required
        />

        <button type='submit' disabled={loading}>
          {loading ? 'Signing In...' : 'Sign In'}
        </button>
      </form>

      <p>
        Not a member?{' '}
        <span className='login_register' onClick={register} style={{cursor: 'pointer', color: 'blue'}}>
          Register Now
        </span>
      </p>
    </div>
  );
}

export default Login;
